export enum SigningPackageType {
  DEFAULT = 'DEFAULT',
  INSURANCE_MANDATE_REQUEST = 'INSURANCE_MANDATE_REQUEST'
}
